(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-video-tile"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmVideoInlineBound) return;
    window.__mmVideoInlineBound = true;

    function bindVideoEvents(video) {
      if (video.__mmBound) return;
      video.__mmBound = true;
      var tile = video.closest('[data-mm-video-inline]');
      if (!tile) return;
      video.addEventListener('play', function () { tile.classList.add('is-playing'); });
      video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { tile.classList.remove('is-playing'); });
    }
    document.querySelectorAll('[data-mm-video-inline] video').forEach(bindVideoEvents);

    document.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-mm-video-inline]');
      if (!tile) return;
      var video = tile.querySelector('video');
      if (!video) return;
      e.preventDefault();
      bindVideoEvents(video);
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.pause();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-offer-stack"] && !Shopify.designMode) return;
  try {
    (function() {
    function mmTrack(name, payload) {
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload || {})); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('mm:analytics', { detail: { event: name, payload: payload || {} } })); } catch (e) {}
    }

    document.querySelectorAll('[data-mm-os]').forEach(function(root) {
      if (root.dataset.mmOsReady === '1') return;
      root.dataset.mmOsReady = '1';

      var variantLookup = {};
      try { variantLookup = JSON.parse(root.querySelector('[data-mm-os-variant-lookup]').textContent || '{}'); } catch (e) {}

      // design value → product (variant featured) image for the "Your set" thumbnails.
      var designImages = {};
      try {
        var diEl = root.querySelector('[data-mm-os-design-images]');
        if (diEl) designImages = JSON.parse(diEl.textContent || '{}');
      } catch (e) {}
      function thumbImageFor(swatch) {
        if (!swatch) return '';
        var dval = swatch.getAttribute('data-value');
        // Prefer the product photo for this print; fall back to the swatch tile.
        return designImages[dval] || swatch.getAttribute('data-swatch-img') || '';
      }

      var designOptName = root.getAttribute('data-design-option-name') || '';
      var designIdx = parseInt(root.getAttribute('data-design-idx'), 10);
      var sizeIdx = parseInt(root.getAttribute('data-size-idx'), 10);

      function getSelectedTier() { return root.querySelector('.mm-os__tier.is-selected'); }

      // Seed each pair's "Your set" thumbnail (product image + size letter) from
      // its current selection. Selection attributes exist before the tier's
      // swatches are lazily painted, so this works on load and on every change.
      function paintSetThumbs(tier) {
        tier.querySelectorAll('[data-mm-os-set-thumb]').forEach(function(thumb) {
          var idx = thumb.getAttribute('data-mm-os-set-thumb');
          var pair = tier.querySelector('.mm-os__pair[data-mm-os-pair="' + idx + '"]');
          if (!pair) return;
          var img = thumb.querySelector('[data-mm-os-set-thumb-img]');
          var url = thumbImageFor(pair.querySelector('.mm-os__swatch.is-selected'));
          if (img && url) img.style.backgroundImage = "url('" + url + "')";
          updateThumbSize(pair);
        });
      }

      // Mirror a pair's selected size into its "Your set" thumbnail overlay.
      function updateThumbSize(pair) {
        var tier = pair.closest('.mm-os__tier');
        if (!tier) return;
        var idx = pair.getAttribute('data-mm-os-pair');
        var sizeEl = tier.querySelector('[data-mm-os-set-thumb="' + idx + '"] [data-mm-os-set-thumb-size]');
        var sel = pair.querySelector('[data-mm-os-pair-size]');
        if (sizeEl && sel) sizeEl.textContent = sel.value;
      }

      // Feed the title/price head's height into the set bar's sticky `top` so it
      // tucks directly beneath the pinned title instead of overlapping it.
      function syncStickyOffset(tier) {
        var head = tier.querySelector('.mm-os__tier-head');
        if (head) tier.style.setProperty('--mm-os-stick-top', head.offsetHeight + 'px');
      }

      // Paint a tier's swatch background images on demand — only the open tier
      // loads images, so the buy box stays light on first paint. Images on the
      // hidden overflow swatches won't fetch until "More" reveals them.
      function paintTier(tier) {
        if (!tier) return;
        syncStickyOffset(tier);
        paintSetThumbs(tier);
        if (tier.dataset.mmPainted === '1') return;
        tier.dataset.mmPainted = '1';
        tier.querySelectorAll('.mm-os__swatch[data-swatch-img]').forEach(function(sw) {
          var url = sw.getAttribute('data-swatch-img');
          if (url) sw.style.backgroundImage = "url('" + url + "')";
        });
      }

      // Mirror the hidden <select>'s value onto the visible size pills.
      function syncSizeButtons(pair) {
        var sel = pair.querySelector('[data-mm-os-pair-size]');
        if (!sel) return;
        var val = sel.value;
        pair.querySelectorAll('[data-mm-os-size-opt]').forEach(function(b) {
          var on = b.getAttribute('data-value') === val;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      // Set a pair's size; tag it FIT when the value came from the Finder.
      function setPairSize(pair, size, fromFinder) {
        var sel = pair.querySelector('[data-mm-os-pair-size]');
        if (!sel) return;
        var has = false;
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === size) { has = true; break; }
        }
        if (has) sel.value = size;
        syncSizeButtons(pair);
        var wrap = pair.querySelector('[data-mm-os-sizesel]');
        if (wrap) wrap.classList.toggle('is-fit', fromFinder === true && has);
        updateThumbSize(pair);
      }

      // ---- Tier selection (radio) vs open (expanded body) are independent ----
      // Tapping a different tier selects + opens it (closing others); re-tapping
      // the selected tier just toggles its panel. So a tier can be selected for
      // Add-to-Cart while collapsed (the default 3-Pairs state).
      var tiers = root.querySelectorAll('.mm-os__tier');

      // Open/close a tier body by animating its explicit height. This reliably
      // collapses to 0 in every browser (the old grid-template-rows approach
      // could fade the contents without shrinking the box). Resting-open height
      // is `auto` so inner changes — e.g. the "+More" swatch toggle — reflow.
      function setTierOpen(tierEl, open, animate) {
        tierEl.classList.toggle('is-open', open);
        var body = tierEl.querySelector('.mm-os__tier-body');
        if (!body) return;
        if (body._mmTE) { body.removeEventListener('transitionend', body._mmTE); body._mmTE = null; }
        if (!animate) { body.style.height = open ? 'auto' : '0px'; return; }
        var startH = body.getBoundingClientRect().height;
        if (open) {
          body.style.height = startH + 'px';
          var full = body.scrollHeight;     // full content height
          void body.offsetHeight;           // reflow so the next set transitions
          body.style.height = full + 'px';
          body._mmTE = function(e) {
            if (e.target !== body || e.propertyName !== 'height') return;
            body.style.height = 'auto';      // let content drive height while open
            body.removeEventListener('transitionend', body._mmTE);
            body._mmTE = null;
          };
          body.addEventListener('transitionend', body._mmTE);
        } else {
          body.style.height = startH + 'px'; // pin current height (may be auto)
          void body.offsetHeight;            // reflow
          body.style.height = '0px';
        }
      }

      function selectTier(tierEl) {
        var wasSelected = tierEl.classList.contains('is-selected');
        var wasOpen = tierEl.classList.contains('is-open');
        tiers.forEach(function(t) {
          var sel = t === tierEl;
          t.classList.toggle('is-selected', sel);
          var input = t.querySelector('[data-mm-os-tier-input]');
          if (input) input.checked = sel;
          if (!sel && t.classList.contains('is-open')) setTierOpen(t, false, true);
        });
        var open = wasSelected ? !wasOpen : true;
        if (open) paintTier(tierEl);
        setTierOpen(tierEl, open, true);
        if (!wasSelected) {
          mmTrack('tier_select', {
            tier: tierEl.getAttribute('data-tier-name') || '',
            qty: parseInt(tierEl.getAttribute('data-tier-qty'), 10) || 1
          });
        }
      }
      tiers.forEach(function(tierEl) {
        var head = tierEl.querySelector('.mm-os__tier-head');
        if (head) {
          head.addEventListener('click', function(e) {
            if (e.target && e.target.matches && e.target.matches('[data-mm-os-tier-input]')) return;
            selectTier(tierEl);
          });
        }
      });

      // ---- Pattern (design) picks — per pair, open grids ----
      root.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-mm-os-pick="design"]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var value = btn.getAttribute('data-value');
        var pair = btn.closest('.mm-os__pair');
        if (!pair) return;
        pair.querySelectorAll('[data-mm-os-pick="design"]').forEach(function(s) {
          var on = s === btn;
          s.classList.toggle('is-selected', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        pair.setAttribute('data-pick-design', value);
        // Mirror the pick into this pair's "Your set" thumbnail (product photo).
        var pickTier = pair.closest('.mm-os__tier');
        if (pickTier) {
          var pickIdx = pair.getAttribute('data-mm-os-pair');
          var pickImg = pickTier.querySelector('[data-mm-os-set-thumb="' + pickIdx + '"] [data-mm-os-set-thumb-img]');
          var pickUrl = thumbImageFor(btn);
          if (pickImg && pickUrl) pickImg.style.backgroundImage = "url('" + pickUrl + "')";
        }
        if (typeof window.__mmSyncGalleryToOption === 'function') {
          window.__mmSyncGalleryToOption(designOptName || 'Design', value);
        }
        mmTrack('pattern_change', { pair: parseInt(pair.getAttribute('data-pair-index'), 10) || 1, design: value });
      });

      // ---- "Your set" thumbnail tap → jump to that pair's grid ----
      root.addEventListener('click', function(e) {
        var thumb = e.target.closest('[data-mm-os-set-thumb]');
        if (!thumb) return;
        e.preventDefault();
        var tierEl = thumb.closest('.mm-os__tier');
        if (!tierEl) return;
        var idx = thumb.getAttribute('data-mm-os-set-thumb');
        tierEl.querySelectorAll('[data-mm-os-set-thumb]').forEach(function(t) {
          t.classList.toggle('is-active', t === thumb);
        });
        var pair = tierEl.querySelector('.mm-os__pair[data-mm-os-pair="' + idx + '"]');
        if (pair && pair.scrollIntoView) pair.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      // ---- "More" toggle ----
      root.addEventListener('click', function(e) {
        var more = e.target.closest('[data-mm-os-more]');
        if (!more) return;
        e.preventDefault();
        var grid = more.closest('[data-mm-os-grid]');
        if (!grid) return;
        var expanded = grid.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var lbl = more.querySelector('[data-mm-os-more-label]');
        if (lbl) lbl.textContent = expanded ? 'Less' : 'More';
      });

      // ---- Per-pair size pills (row of options) ----
      root.addEventListener('click', function(e) {
        var opt = e.target.closest('[data-mm-os-size-opt]');
        if (!opt) return;
        e.preventDefault();
        var pair = opt.closest('.mm-os__pair');
        if (!pair) return;
        var value = opt.getAttribute('data-value');
        var sel = pair.querySelector('[data-mm-os-pair-size]');
        if (sel) sel.value = value;
        syncSizeButtons(pair);
        // Manual pick — clear any FIT tag the Finder may have set.
        var wrap = pair.querySelector('[data-mm-os-sizesel]');
        if (wrap) wrap.classList.remove('is-fit');
        updateThumbSize(pair);
        try { window.dispatchEvent(new CustomEvent('mm:size:changed', { detail: { size: value, source: 'pair' } })); } catch (err) {}
        if (typeof window.__mmHighlightChartRow === 'function') window.__mmHighlightChartRow(value);
      });

      // ---- "Your set" collapse toggle ----
      root.addEventListener('click', function(e) {
        var tog = e.target.closest('[data-mm-os-set-toggle]');
        if (!tog) return;
        e.preventDefault();
        var setEl = tog.closest('[data-mm-os-set]');
        if (!setEl) return;
        var collapsed = setEl.classList.toggle('is-collapsed');
        tog.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });

      // ---- Entry points to the Fit Finder / size chart ----
      root.addEventListener('click', function(e) {
        if (e.target.closest('[data-mm-os-find-fit]')) {
          e.preventDefault();
          if (typeof window.__mmOpenSizing === 'function') window.__mmOpenSizing('finder', 'size-selector');
          return;
        }
        if (e.target.closest('[data-mm-os-size-guide]')) {
          e.preventDefault();
          if (typeof window.__mmOpenSizing === 'function') window.__mmOpenSizing('chart', 'size-guide');
        }
      });

      // ---- Public bridge so the Finder + chart can write the size ----
      // Applies one size to EVERY pair of the selected tier (the common case);
      // the customer can still fine-tune an individual pair afterwards.
      window.MMOfferStack = {
        applySize: function(size, source) {
          var tier = getSelectedTier() || root.querySelector('.mm-os__tier');
          if (!tier) return;
          if (!tier.classList.contains('is-selected')) selectTier(tier);
          tier.setAttribute('data-tier-size', size);
          tier.querySelectorAll('.mm-os__pair').forEach(function(pair) {
            setPairSize(pair, size, source === 'finder');
          });
          try { window.dispatchEvent(new CustomEvent('mm:size:changed', { detail: { size: size, source: source || 'apply' } })); } catch (e) {}
          if (typeof window.__mmHighlightChartRow === 'function') window.__mmHighlightChartRow(size);
        },
        getSize: function() {
          var tier = getSelectedTier();
          if (!tier) return root.getAttribute('data-default-size') || '';
          var sel = tier.querySelector('[data-mm-os-pair-size]');
          if (sel) return sel.value;
          return tier.getAttribute('data-tier-size') || root.getAttribute('data-default-size') || '';
        }
      };

      // ---- Add to cart ----
      var atc = root.querySelector('[data-mm-os-atc]');
      if (atc) {
        atc.addEventListener('click', function() {
          var tier = getSelectedTier();
          var labelEl = atc.querySelector('.mm-os__atc-label');
          var origLabel = labelEl ? labelEl.textContent : 'Add to Cart';

          if (!tier) {
            if (labelEl) { labelEl.textContent = 'Choose an offer above'; setTimeout(function() { labelEl.textContent = origLabel; }, 1600); }
            var firstTier = root.querySelector('.mm-os__tier');
            if (firstTier) firstTier.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }

          var tierName = tier.getAttribute('data-tier-name') || '';
          var defaultSize = tier.getAttribute('data-tier-size') || root.getAttribute('data-default-size') || '';
          var pairs = tier.querySelectorAll('.mm-os__pair');
          var tierQty = pairs.length || (parseInt(tier.getAttribute('data-tier-qty'), 10) || 1);

          var pairList = Array.prototype.slice.call(pairs);
          if (!pairList.length) { for (var k = 0; k < tierQty; k++) pairList.push(null); }

          var items = [];
          var payloadPatterns = [];
          var payloadSizes = [];
          var unresolved = null;
          for (var i = 0; i < pairList.length; i++) {
            var pair = pairList[i];
            var design = pair ? (pair.getAttribute('data-pick-design') || pair.getAttribute('data-default-design') || '') : '';
            var sel = pair ? pair.querySelector('[data-mm-os-pair-size]') : null;
            var size = sel ? sel.value : defaultSize;

            var opts = ['', '', ''];
            if (designIdx >= 0 && designIdx <= 2) opts[designIdx] = design;
            if (sizeIdx >= 0 && sizeIdx <= 2) opts[sizeIdx] = size;
            var key = opts.join('|');
            var variantId = variantLookup[key];
            if (!variantId) { unresolved = { pair: i + 1, design: design, size: size }; break; }

            payloadPatterns.push(design);
            payloadSizes.push(size);
            items.push({ id: parseInt(variantId, 10), quantity: 1, properties: { '_bundle': tierName, '_bundle_pair': (i + 1) + ' of ' + tierQty } });
          }

          if (unresolved || !items.length) {
            if (labelEl) { labelEl.textContent = 'Selection unavailable'; setTimeout(function() { labelEl.textContent = origLabel; }, 1600); }
            return;
          }

          mmTrack('add_to_cart', { tier: tierName, qty: tierQty, sizes: payloadSizes, patterns: payloadPatterns });

          atc.disabled = true;
          if (labelEl) labelEl.textContent = 'Adding…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function(r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('mm:cart:updated'));
            if (labelEl) labelEl.textContent = '✓ Added';
            setTimeout(function() {
              var opener = document.querySelector('[data-mm-action="open-cart"]');
              if (opener) { opener.click(); } else { window.location.href = '/cart'; }
              atc.disabled = false;
              if (labelEl) labelEl.textContent = origLabel;
            }, 400);
          })
          .catch(function() {
            atc.disabled = false;
            if (labelEl) labelEl.textContent = origLabel;
          });
        });
      }

      // Prime every tier: measure the title/price head so the set bar pins
      // directly beneath it, and seed each pair's "Your set" thumbnail. Recompute
      // the offset on resize so it tracks any reflow of the title/price row.
      tiers.forEach(function(t) { syncStickyOffset(t); paintSetThumbs(t); });
      window.addEventListener('resize', function() {
        tiers.forEach(function(t) { syncStickyOffset(t); });
      });

      // Paint + open any tier already expanded on load (the default tier). The
      // body's resting height is 0 in CSS, so set it to auto here without an
      // animation; collapsed tiers stay at height 0 until first opened.
      root.querySelectorAll('.mm-os__tier.is-open').forEach(function(t) {
        paintTier(t);
        var b = t.querySelector('.mm-os__tier-body');
        if (b) b.style.height = 'auto';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-return-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.querySelector('[data-policy-return-bar]');
    if (!bar) return;
    var link = bar.querySelector('[data-policy-return-link]');
    var label = bar.querySelector('[data-policy-return-label]');
    if (!link || !label) return;

    var ref = document.referrer || '';
    var sameOrigin = false;
    var refUrl = null;
    try {
      if (ref) {
        refUrl = new URL(ref);
        sameOrigin = refUrl.origin === window.location.origin
          && refUrl.pathname !== window.location.pathname;
      }
    } catch (e) {}

    if (sameOrigin && refUrl) {
      link.setAttribute('href', refUrl.pathname + refUrl.search + refUrl.hash);

      var path = refUrl.pathname.replace(/\/+$/, '');
      var segs = path.split('/').filter(Boolean);
      var newLabel = '';

      if (segs[0] === 'products' && segs[1]) {
        newLabel = 'Return to ' + prettify(segs[1]);
      } else if (segs[0] === 'collections' && segs[1] && segs[1] !== 'all') {
        if (segs[2] === 'products' && segs[3]) {
          newLabel = 'Return to ' + prettify(segs[3]);
        } else {
          newLabel = 'Return to ' + prettify(segs[1]);
        }
      } else if (segs[0] === 'collections') {
        newLabel = 'Return to shop';
      } else if (segs[0] === 'cart') {
        newLabel = 'Return to cart';
      } else if (segs[0] === 'blogs' && segs[2]) {
        newLabel = 'Return to ' + prettify(segs[2]);
      } else if (segs[0] === 'pages' && segs[1]) {
        newLabel = 'Return to ' + prettify(segs[1]);
      } else if (segs.length === 0) {
        newLabel = 'Return to home';
      } else {
        newLabel = 'Return to previous page';
      }

      label.textContent = newLabel;

      link.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (window.history.length > 1) {
          e.preventDefault();
          window.history.back();
        }
      });
    }

    function prettify(slug) {
      var s = decodeURIComponent(slug).replace(/[-_]+/g, ' ').trim();
      return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
